import { z } from "zod";

export const WorkflowEnvResponseSchema = z.object({
	env: z.record(z.string(), z.string()),
});

export const UpdateWorkflowEnvRequestSchema = z.object({
	env: z.record(z.string(), z.string()),
});

export type WorkflowEnvResponse = z.infer<typeof WorkflowEnvResponseSchema>;
export type UpdateWorkflowEnvRequest = z.infer<typeof UpdateWorkflowEnvRequestSchema>;
